import React, { useEffect, useState, useCallback } from 'react';
import { useDispatch, useSelector, shallowEqual } from 'react-redux';
import block from 'bem-cn';
import { useHistory } from 'react-router-dom';

import { actions as userActions } from 'features/users/redux';
import Input from 'components/Input/desktop';
import Spinner from 'components/Spinner';
import Button from 'components/Button';
import PopUp from 'components/PopUp';

import './ChangePas.scss';

const b = block('change-pas-desktop');

const ChangePas = () => {
  const dispatch = useDispatch();
  const history = useHistory();

  const { id } = useSelector(state => state.auth);
  const locale = useSelector(state => state.locale.locale, shallowEqual);
  const { actionProcessing } = useSelector(state => state.users, shallowEqual);

  const [oldPassword, editOldPassword] = useState('');
  const [newPassword, editNewPassword] = useState('');
  const [repeatNewPassword, editRepeatNewPassword] = useState('');
  const onSubmit = useCallback(
    e => {
      e.preventDefault();
      dispatch(userActions.changePassword({ id, oldPassword, newPassword, repeatNewPassword }));
    },
    [id, newPassword, oldPassword, repeatNewPassword],
  );

  return (
    <section className={b()}>
      <Spinner isLoading={actionProcessing} />
      <section className={b('content')}>
        <div className={b('title')}>{locale.changePassword}</div>
        <div className={b('main')}>
          <form className={b('form')} onSubmit={onSubmit}>
            <label className={b('item')}>
              <p className={b('item-title')}>{locale.newPassword}</p>
              <div className={b('item-field')}>
                <Input
                  value={newPassword}
                  name="new-password"
                  placeholder={locale.newPassword}
                  type="password"
                  onChange={e => editNewPassword(e.currentTarget.value)}
                  autoComplete="one-time-code"
                />
              </div>
              <p className={b('item-desc')}>{locale.newPasswordDescription}</p>
            </label>

            <div className={b('button')}>
              <Button type="submit">{locale.changePassword}</Button>
            </div>
          </form>
        </div>
      </section>
    </section>
  );
};

export default ChangePas;
